import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/RichText.css';

const RichText = ({ content }) => {
  if (!content) return null;

  // Regex patterns
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const mentionRegex = /@(\w+)/g;
  const hashtagRegex = /#(\w+)/g;

  let parts = [content];

  // Parse URLs
  parts = parts.flatMap(part => {
    if (typeof part !== 'string') return part;
    return part.split(urlRegex).map((text, i) => {
      if (urlRegex.test(text)) {
        return (
          <a 
            key={`url-${i}`}
            href={text} 
            target="_blank" 
            rel="noopener noreferrer"
            className="rich-link"
          >
            {text}
          </a>
        );
      }
      return text;
    });
  });

  // Parse mentions
  parts = parts.flatMap(part => {
    if (!typeof part === 'string' || React.isValidElement(part)) return part;
    if (typeof part !== 'string') return part;
    
    return part.split(mentionRegex).map((text, i) => {
      if (text && text.match(/^\w+$/) && i % 2 === 1) {
        // This is a username
        return (
          <Link 
            key={`mention-${i}`}
            to={`/search?query=@${text}`}
            className="rich-mention"
          >
            @{text}
          </Link>
        );
      }
      return text;
    });
  });

  // Parse hashtags
  parts = parts.flatMap(part => {
    if (!React.isValidElement(part) && typeof part === 'string') {
      return part.split(hashtagRegex).map((text, i) => {
        if (text && text.match(/^\w+$/) && i % 2 === 1) {
          // This is a hashtag
          return (
            <Link 
              key={`hashtag-${i}`}
              to={`/hashtag/${text}`}
              className="rich-hashtag"
            >
              #{text}
            </Link>
          );
        }
        return text;
      });
    }
    return part;
  });

  return <div className="rich-text">{parts}</div>;
};

export default RichText;
